//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import DetailChart from '~/components/detail/mobile/detail_chart'
// import DetailConverter from '~/components/detail/mobile/detail_converter'
import SingleLoading from '~/components/partials/loading/single_loading'
export default {
  name: 'ChartConverter',
  components: {
    DetailChart,
    // DetailConverter,
    SingleLoading
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      intervals: ['1D', '1W', '1M'],
      selectedInterval: '',
      oneDayTimestamp: 24 * 3400 * 1000,
      nowTime: new Date().getTime(),
      disableInterval: false,
      symbol: 'USDT'
    }
  },
  computed: {
    ...mapGetters({
      loading: 'coins/loading'
    })
  },
  watch: {
    selectedInterval: {
      async handler (val) {
        if (this.data.chart_slug) {
          if (val === '1D') {
            await this.getData(val, 1)
          } else if (val === '1W') {
            await this.getData('7D', 7)
          } else {
            await this.getData(val, 30)
          }
        }
      }
    }
  },
  mounted () {
    this.selectedInterval = '1D'
  },
  methods: {
    async getData (interval, day) {
      this.disableInterval = true
      await this.$store.dispatch('coins/getChartData', {
        symbol: this.data.chart_slug,
        interval,
        start: this.nowTime - (this.oneDayTimestamp * day)
      })
      this.disableInterval = false
    }
  }
}
